var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mt40"},[_c('el-checkbox',{on:{"change":_vm.emitChecked},model:{value:(_vm.agreement),callback:function ($$v) {_vm.agreement=$$v},expression:"agreement"}},[_c('span',{staticClass:"g6"},[_vm._v("我已阅读，理解并接受")])]),_vm._v(" "),_c('span',{staticClass:"green poi",on:{"click":_vm.openSp}},[_vm._v("《中企域名高级服务协议》")])],1),_vm._v(" "),_c('advanced-domain-register-service-protocol',{attrs:{"visible":_vm.SpVisible},on:{"update:visible":function($event){_vm.SpVisible=$event},"close":_vm.CloseSp}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/Protocol.vue